import { i18n } from "../../../i18n";
const validatorPhone = (rule, value, callback) => {
  if (value.toString().length !== 10) {
    callback(
      new Error(i18n.global.tc("accountSettings.rules.phoneNumberLength"))
    );
  } else {
    callback();
  }
};
export const bookingFormProps = {
  firstName: [
    {
      required: true,
      message: i18n.global.tc("accountSettings.rules.name"),
      trigger: "blur",
    },
  ],
  lastName: [
    {
      required: true,
      message: i18n.global.tc("accountSettings.rules.lastName"),
      trigger: "blur",
    },
  ],
  secondLastName: [
    {
      required: true,
      message: i18n.global.tc("accountSettings.rules.secondLastName"),
      trigger: "blur",
    },
  ],
  participantPhone: [
    {
      required: true,
      message: i18n.global.tc("accountSettings.rules.phoneNumber"),
      trigger: "blur",
    },
    {
      type: "number",
      message: i18n.global.tc("accountSettings.rules.phoneNumberOnlyDigits"),
    },
    { validator: validatorPhone, trigger: "blur" },
  ],
  email: [
    {
      required: true,
      message: i18n.global.tc("accountSettings.rules.address"),
      trigger: "blur",
    },
    {
      type: "email",
      message: i18n.global.tc("hotels.bookingCheckout.rules.email"),
      trigger: ["blur", "change"],
    },
  ],
};
export const optionalBookingFormProps = {
  firstName: [
    {
      required: true,
      message: i18n.global.tc("accountSettings.rules.name"),
      trigger: "blur",
    },
  ],
  lastName: [
    {
      required: true,
      message: i18n.global.tc("accountSettings.rules.lastName"),
      trigger: "blur",
    },
  ],
  secondLastName: [
    {
      required: true,
      message: i18n.global.tc("accountSettings.rules.secondLastName"),
      trigger: "blur",
    },
  ],
};
